import { render, staticRenderFns } from "./price_type_templates.vue?vue&type=template&id=76451a78&"
import script from "./price_type_templates.vue?vue&type=script&lang=js&"
export * from "./price_type_templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports